import { useLanguage } from '../../../hooks/useLanguage';

export default function USPsNew() {
  const { language } = useLanguage();

  const content = {
    de: {
      label: 'Warum TELIQone',
      headline: 'Gebaut für Telcos, optimiert für Effizienz',
      usps: [
        {
          icon: 'ri-flashlight-line',
          title: 'Schnelle Integration',
          description: 'Plug-and-Play-Anbindung an bestehende Systeme. Keine monatelangen Implementierungsprojekte.'
        },
        {
          icon: 'ri-shield-check-line',
          title: 'DSGVO-konform',
          description: 'Hosting in Deutschland, vollständige Datenkontrolle, zertifizierte Sicherheitsstandards.'
        },
        {
          icon: 'ri-line-chart-line',
          title: 'Skalierbar',
          description: 'Von 1.000 bis 1 Million Tickets pro Monat — die Plattform wächst mit Ihrem Geschäft.'
        },
        {
          icon: 'ri-customer-service-2-line',
          title: 'Deutscher Support',
          description: 'Persönlicher Ansprechpartner, technischer Support und kontinuierliche Optimierung.'
        }
      ]
    },
    en: {
      label: 'Why TELIQone',
      headline: 'Built for telcos, optimized for efficiency',
      usps: [
        {
          icon: 'ri-flashlight-line',
          title: 'Fast Integration',
          description: 'Plug-and-play connection to existing systems. No months-long implementation projects.'
        },
        {
          icon: 'ri-shield-check-line',
          title: 'GDPR Compliant',
          description: 'Hosting in Germany, full data control, certified security standards.'
        },
        {
          icon: 'ri-line-chart-line',
          title: 'Scalable',
          description: 'From 1,000 to 1 million tickets per month — the platform grows with your business.'
        },
        {
          icon: 'ri-customer-service-2-line',
          title: 'German Support',
          description: 'Personal contact, technical support, and continuous optimization.'
        }
      ]
    }
  };

  const t = content[language];

  return (
    <section id="usps" className="relative py-20 sm:py-28 bg-black">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="text-center mb-12 sm:mb-16 fade-in-section">
          <div className="inline-block px-3 py-1 bg-blue-500/10 border border-blue-500/30 rounded-full mb-4">
            <span className="text-blue-400 text-xs font-semibold uppercase tracking-widest">{t.label}</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-4 leading-tight">
            {t.headline}
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-5">
          {t.usps.map((usp, i) => (
            <div
              key={i}
              className="fade-in-section bg-white/5 border border-white/10 rounded-xl p-6 sm:p-8 hover:border-blue-500/40 transition-all group"
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <div className="w-12 h-12 flex items-center justify-center bg-blue-500/10 rounded-lg mb-4 group-hover:bg-blue-500/20 transition-all">
                <i className={`${usp.icon} text-2xl text-blue-500`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-2">{usp.title}</h3>
              <p className="text-sm text-white/60 leading-relaxed">{usp.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}